module.exports = __webpack_public_path__ + "static/media/cover-img4.0a300152.jpg";